import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../util/arraysUtil';
import { required, renderFieldSelect } from '../../util/inputs';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
export class FormCadastroEmissaoMdfe extends Component {

    render() {
        return (
            <div>
                {/* Campos fixos / gerados automaticamente */}
                <div className="form-row">
                    <div className="col-12 col-sm-2 col-md-2">
                        <Field name="numeroMdfe" type="text" component={renderField}
                            label="Número MDF-e:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-2 col-md-2">
                        <Field name="modelo" type="text" component={renderField}
                            label="Modelo:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-2 col-md-2">
                        <Field name="serie" type="text" component={renderField}
                            label="Série:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-1 col-md-1">
                        <Field name="dv" type="text" component={renderField}
                            label="DV:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-3 col-md-3">
                        <label className='mt-2'>Data Emissão:</label>
                        <DatePicker
                            readOnly={true}
                            className='form-control col-md-12'
                            value={this.props.dataEmissao}
                            locale="pt-BR"
                            selected={this.props.dataEmissao && moment(this.props.dataEmissao).toDate()}
                            dateFormat="dd/MM/yyyy"
                            disabled={true}
                            customInput={<InputMask mask="99/99/9999" />}
                        />
                    </div>
                    <div className="col-12 col-sm-2 col-md-2">
                        <Field name="horaEmissao" type="text" component={renderField}
                            label='Hora Emissão:'
                            css="form-control" readOnly={true} />
                    </div>
                </div>

                {/* Campos fixos com descrição */}
                <div className="form-row">
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="tipoEmitente" type="text" component={renderField}
                            label="Tipo Emitente:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="modal" type="text" component={renderField}
                            label="Modal:"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="tipoCarga" type="text" component={renderField}
                            label="Tipo da Carga:"
                            css="form-control" readOnly={true} />
                    </div>
                </div>

                {/* Cidades */}
                <div className="form-row">
                    {this.props.exibirCampoBusca()}
                </div>

                {/* Veículo */}
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='veiculo'
                            options={(this.props.veiculos || []).map(elemento => ({
                                descricao: elemento.descricao,
                                nome: elemento.id
                            }))}
                            component={renderFieldSelect}
                            label="Veículo (Placa):"
                            placeholder='Selecione a placa...'
                            onChange={(e) => this.props.handleSelecionarVeiculo(e)}
                            disabled={this.props.somenteLeitura()}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='motorista'
                            options={(this.props.motoristas || []).map(elemento => ({
                                descricao: elemento.nome,
                                nome: elemento.id
                            }))}
                            component={renderFieldSelect}
                            label="Motorista:"
                            placeholder='Selecione o motorista...'
                            onChange={(e) => this.props.handleSelecionarMotorista(e)}
                            disabled={this.props.somenteLeitura()}
                        />
                    </div>
                </div>

                {/* Seguro */}
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="empresaSeguroVeiculo" type="text" component={renderField}
                            label="Seguro (veículo):"
                            css="form-control" readOnly={true} />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="responsavelSeguro" type="text" component={renderField}
                            label="Responsável Seguro:"
                            css="form-control" readOnly={true} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="apolice" type="text" validate={[required]} component={renderField}
                            label="Apólice:"
                            css="form-control"
                            readOnly={this.props.somenteLeitura()} />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="averbacao" type="text" component={renderField}
                            label="Averbação:"
                            css="form-control"
                            disabled={true}
                            readOnly={true} />
                    </div>
                </div>

                {/* CNPJ autorizado */}
                <div className="form-row">
                    <div className="col-12 col-sm-12 col-md-12">
                        <Field name="cnpjAutorizadoBaixarXml" type="text" component={renderField}
                            label="CNPJ Autorizado Baixar XML:"
                            css="form-control"
                            disabled={true}
                            readOnly={true} />
                    </div>
                </div>

            </div>
        )
    }
}

export function mapStateToProps(state) {    
    return {
        empresaSelecionada: state.empresaSelecionada,
        veiculos: state.opcoesFiltrosEmissoesMdfe.veiculos,        
        seguros: state.opcoesFiltrosEmissoesMdfe.seguros,
        motoristas: state.opcoesFiltrosEmissoesMdfe.motoristas,
    }
}

export default connect(mapStateToProps, {})(reduxForm({
    form: 'formularioCadastroMdfe'
})(FormCadastroEmissaoMdfe));
